import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a5a4f85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Import-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"padding":"0 10%"} }, "Импорт данных", -1))
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_DxTabPanel, {
      class: "Import-panel",
      key: _ctx.tabsRenderKey,
      height: "100%",
      "data-source": _ctx.tabs,
      "selected-index": _ctx.selectedTabIndex,
      "onUpdate:selected-index": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
      loop: false,
      "animation-enabled": false,
      "swipe-enabled": false
    }, {
      title: _withCtx(({ data: tab }) => [
        _createElementVNode("span", null, _toDisplayString(tab.name), 1)
      ]),
      item: _withCtx(({ data: tab }) => [
        _createElementVNode("div", {
          id: tab.domId
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["data-source", "selected-index"])
  ]))
}